import React, { useEffect, useContext, useState } from "react";
import { GlobalContext } from '../../context/hoa-global-context';

import dashboardServices from '../../services/hoa-dashboard-api-service';
import config from '../../hoa-config';
import { LinearProgress, Button, Container, TextField } from '@mui/material';

import Modal from "@mui/material/Modal";
import SearchIcon from '@mui/icons-material/SearchRounded';
import TableLayout from "../table-layout/hoa-table-layout";

export default function AssignPropertyModal(props: any) {
    const { property, updatePropertyData, updateView, selectedValues, updateSelectedValues, view: views } = useContext<any>(GlobalContext);
    
    const stateList : any = {
        street: "",
        city: "",
        market: "",
        state: ""
    }

    const { modalOpen, toggleModalOpen, assignedProperty, setAssignedProperty } = props;
    
    const [state, setState] = useState(stateList);
    const [loading, setLoading] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);

    const headers = config.dashboard["PropertiesModalTable"]?.tableLayout?.title;
	const columns = config.dashboard["PropertiesModalTable"]?.tableLayout?.columns;

    useEffect(() => {
        setSelectedProperty(assignedProperty);
    }, [assignedProperty]);

    const onClose = () => {
        toggleModalOpen(false);
    }

    const handleChange = (value: any, key: string) => {
        let tempState : any = {...state};
        tempState[key] = value;
        setState(tempState);
    }

    const getProperties = async (numberOfProperties: number, pageNo: number) => {
		const { data } = await dashboardServices.getProperties(numberOfProperties, pageNo, state);
		return {
            data: data.properties,
            count: data.parseCount
        };
	};

    const searchProperty = () => {
        updatePropertyData({
            ...property,
            data: [],
            pageNumber: 1,
            options: state,
            isLastPage: false,
            fetchingFilteredData: true,
        })
    }

    const handleMailAssignedToProperty = (data: any) => {
        if(data) {
            setSelectedProperty(data);
        }
    }

    const saveSelectedProperty = () => {
        if(selectedProperty) {
            setAssignedProperty(selectedProperty);
            setSelectedProperty(null);
            toggleModalOpen(false);
        }
    }

    return (
        <Modal onClose={onClose} open={modalOpen}>
            <Container
                style={{
                    background: "white",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "50%",
                    maxHeight: "850px",
                    overflow: "auto",
                    padding: "0px",
                }}
            >
                <div className="modal-wrapper-doc">
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        padding: "24px 16px 24px 24px",
                        gap: "16px",
                        background: "#EFF4FC",
                        border: "1px solid #E8E8E8",
                    }}>
                        <div className="mail-assign-modal-title">Assign Property</div>
                        <div className="mail-assign-modal-subtitle">Please select the necessary information & property to assign the document</div>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        padding: "24px 16px 24px 24px",
                        gap: "16px",
                        boxShadow: "inset 0px -1px 0px #E8E8E8"
                    }}>
                        <div className="mail-assign-sent-to-title">Email Sent To</div>
                        <div className="mail-assign-sent-to-text">{selectedValues.sendTo?.address}</div>
                    </div>
                    <div style={{ padding: 24, marginBottom: 24 }}>
                        <TextField style={{ width: "35%" }} variant="standard" label="Property Address/street name" value={state.street}
                            onChange={(e)=>{handleChange(e.target.value, "street")}} InputLabelProps={{style:{fontSize:"14px"}}}
                            InputProps={{style:{ padding:"7px 0px"}}}
                        />
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "flex-end", paddingBottom: 24, boxShadow: "inset 0px -1px 0px #E8E8E8"}}>
                            <TextField style={{ width: "25%", marginRight: 10 }} variant="standard" label="City" value={state.city}
                                onChange={(e)=>{handleChange(e.target.value, "city")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}}
                            />
                            <TextField style={{ width: "25%", marginRight: 10 }} variant="standard" label="Market" value={state.market}
                                onChange={(e)=>{handleChange(e.target.value, "market")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}}
                            />
                            <TextField style={{ width: "25%", marginRight: 10 }} variant="standard" label="State" value={state.state}
                                onChange={(e)=>{handleChange(e.target.value, "state")}} InputLabelProps={{style:{fontSize:"14px"}}}
                                InputProps={{style:{ padding:"7px 0px"}}}
                            />
                            <Button style={{ height: 40, width: 136 }} startIcon={<SearchIcon color="primary"/>} variant="outlined" onClick={()=> searchProperty()}>
                                Search
                            </Button>                            
                        </div>

                        <TableLayout
                            fetchResult={getProperties}
                            headers={headers}
                            columns={columns}
                            tagType={"Property"}
                            updateSelectedValues={updateSelectedValues}
                            isAssigningMailToProperty={true}
                            handleMailAssignedToProperty={handleMailAssignedToProperty}
                            selectedProperty={selectedProperty}
                        />
                        <div style={{ display: "flex", justifyContent: "flex-end", borderTop: "1px solid #E8E8E8", paddingTop: 14 }}>
                            <Button variant="outlined" color="primary" style={{ width: 105, marginRight: 14 }} onClick={() => toggleModalOpen(false)}>
                                Cancel
                            </Button>
                            <Button variant="contained" color="primary" style={{ width: 105 }} disabled={!selectedProperty} onClick={saveSelectedProperty}>
                                Select
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>
        </Modal>
    );
}